import type { DataTypes } from 'fitify-ui-landing/src/@types'

export const businessFeaturesData: DataTypes.FeatureItem[] = [
  {
    title: 'landing_work_feature_block_1_title',
    content: 'landing_work_feature_block_1_subtitle',
    image: '/assets/images/features/business-1.webp',
    imageSet: '/assets/images/features/business-1.webp',
  },
  {
    title: 'landing_work_feature_block_2_title',
    content: 'landing_work_feature_block_2_subtitle',
    image: '/assets/images/features/business-2.webp',
    imageSet: '/assets/images/features/business-2.webp',
  },
  {
    title: 'landing_work_feature_block_3_title',
    content: 'landing_work_feature_block_3_subtitle',
    image: '/assets/images/features/business-3.webp',
    imageSet: '/assets/images/features/business-3.webp',
  },
  {
    title: 'landing_work_feature_block_4_title',
    content: 'landing_work_feature_block_4_subtitle',
    image: '/assets/images/features/business-4.webp',
    imageSet: '/assets/images/features/business-4.webp',
  },
]
